import { Component, OnInit, ViewContainerRef } from "@angular/core";
import { ToastsManager } from "ng2-toastr/ng2-toastr";
import { AlertService } from "../../_services/alert.service";

@Component({
  moduleId: module.id,
  selector: "alert",
  templateUrl: "./alert.component.html",
})
export class AlertComponent implements OnInit {
  public message: {
    type:
      | "success"
      | "warning"
      | "info"
      | "error"
      | "info-process"
      | "clear-all-toasts";
    text: string;
  };
  public panel: boolean = false;
  public toasterOptions = { maxShown: 2, toastLife: 5000 };

  constructor(
    private alertService: AlertService,
    private toaster: ToastsManager,
    private vcr: ViewContainerRef
  ) {}

  public ngOnInit() {
    this.toaster.setRootViewContainerRef(this.vcr);

    this.alertService.getMessage().subscribe((message) => {
      this.message = message;

      if (this.message && this.message.type && !this.panel) {
        switch (this.message.type) {
          case "success":
            this.toaster
              .success(this.message.text, "הצלחה!", this.toasterOptions)
              .then();
            break;
          case "info":
            this.toaster
              .info(this.message.text, "הודעה", this.toasterOptions)
              .then();
            break;
          case "info-process":
            this.toaster
              .custom(``, "בתהליך הורדת הקובץ", {
                ...this.toasterOptions,
                enableHTML: true,
              })
              .then();
            break;
          case "warning":
            this.toaster
              .warning(this.message.text, "אזהרה!", this.toasterOptions)
              .then();
            break;
          case "clear-all-toasts":
            this.toaster.clearAllToasts();
            break;
          case "error":
          default:
            this.toaster.clearAllToasts();
            this.toaster
              .error(this.message.text, "שגיאה!", this.toasterOptions)
              .then();
            break;
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/_directives/alert/alert.component.ts